import { bootstrapApplication } from "@/bootstrap";
import { renderBootstrapFailure } from "@/bootstrapFailure";
import {
  clearChunkReloadGuard,
  registerChunkReloadGuard,
} from "@/chunkReloadGuard";
import { shouldShowDockingOnboarding } from "@/features/mix-onboarding/lib/dockingOnboarding";
import {
  isMobilePwaTarget,
  isRunningAsInstalledPwa,
  pwaInstallPromptStore,
  shouldCapturePwaInstallPrompt,
} from "@/features/mix-onboarding/lib/pwaInstallPrompt";
import { applyManifestLink } from "@/manifestLink";
import { resolveMountBasePath } from "@/mountPath";
import { runWhenIdle } from "@/shared/lib/runWhenIdle";
import { runStorageRescues } from "@/shared/lib/updateIndexDb/updateindexDB";
import { registerServiceWorker } from "@/swRegistration";
// HTML entryから読むことで、Viteがindex.htmlへ<link rel="stylesheet">を出す。
// app.tsx側に置くとdynamic importの依存になり、GET /boards/{slug}の完了後まで
// CSSの取得が始まらずFOUCとLCP遅延を招く。
import "@/index.css";

// 遅延chunkの取得はbootstrapの後にも起きるため、最初に登録しておく。
registerChunkReloadGuard();

// beforeinstallpromptは発火時刻が保証されないため、対象の初回スマホ訪問では
// bootstrapより先に保持する。通過済み・PC・他mountのブラウザ既定UIは抑止しない。
if (
  shouldCapturePwaInstallPrompt({
    isMixMount: resolveMountBasePath(globalThis.location.pathname) === "/mix",
    isOnboardingRequired: shouldShowDockingOnboarding(),
    isMobileDisplay: isMobilePwaTarget(),
    isInstalledPwa: isRunningAsInstalledPwa(),
  })
) {
  pwaInstallPromptStore.startCapture();
}

// 静的配信のHTMLは全mount共通のため、metadata往復を待たず先にmountへ向ける。
applyManifestLink();

try {
  await bootstrapApplication();
  // bootstrap中に別タブで完了していた場合は、custom UIが無いためcaptureを解除する。
  if (!shouldShowDockingOnboarding()) pwaInstallPromptStore.stopCapture();
  clearChunkReloadGuard();
  // 起動完了後に登録し、初回描画のネットワークとSW installを競合させない
  void registerServiceWorker();
  // 旧storageスキーマの救済は、初回描画とService Worker登録を優先してidleで走らせる
  runWhenIdle(runStorageRescues);
} catch (error) {
  // 起動失敗画面にはcustom install UIが無いため、ブラウザ既定UIを妨げない。
  pwaInstallPromptStore.stopCapture();
  console.error("Application bootstrap failed", error);
  renderBootstrapFailure();
}
